import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#refinance-app', App);
